"use strict";
import React from "react";
var StatusTagStyle = /* @__PURE__ */ ((StatusTagStyle2) => {
  StatusTagStyle2["Default"] = "neutral";
  StatusTagStyle2["Success"] = "success";
  StatusTagStyle2["Info"] = "active";
  StatusTagStyle2["Warning"] = "warning";
  StatusTagStyle2["Alert"] = "alert";
  return StatusTagStyle2;
})(StatusTagStyle || {});
var StatusTagSize = /* @__PURE__ */ ((StatusTagSize2) => {
  StatusTagSize2["Small"] = "small";
  StatusTagSize2["Medium"] = "default";
  return StatusTagSize2;
})(StatusTagSize || {});
function StatusTag(props) {
  const classes = [
    "v3__status-tag",
    `v3__status-tag--color-${props.style || "neutral" /* Default */}`,
    `v3__status-tag--size-${props.size || "default" /* Medium */}`
  ];
  if (props.outlined) {
    classes.push("v3__status-tag--subtle");
  }
  return /* @__PURE__ */ React.createElement("span", { className: classes.join(" "), style: { boxSizing: "content-box" } }, props.content);
}
export { StatusTag, StatusTagStyle, StatusTagSize };
